// src/components/PlayerMicroProfileModal.jsx

import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Button,
  VStack, Text, Box, Heading, Avatar, HStack, Tag
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthCliente } from '../context/AuthClienteContext';

export default function PlayerMicroProfileModal({ isOpen, onClose, member }) {
    const { currentUser } = useAuthCliente();
  if (!member) return null;

  // Lógica para calcular edad y sexo (reutilizada de PlayerProfileModal)
  const birth = member.birthDate ? new Date(member.birthDate) : null;
  const age = birth ? Math.floor((Date.now() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000)) : 'N/A';
  const sexoLabel = member.sexo?.startsWith('f') ? 'Femenino' : (member.sexo?.startsWith('m') ? 'Masculino' : 'N/A');
  const categoryLabel = member.category || 'N/A';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="xl" overflow="hidden">
        <ModalCloseButton color="white" _focus={{ boxShadow: 'none' }} />
        
        <Box bg="green.800" p={6} textAlign="center">
          <Avatar size="2xl" name={member.name} src={member.photoURL} mb={4} />
          <Heading size="lg" color="white">{member.name}</Heading>
          <HStack spacing={3} justify="center" mt={2}>
            {sexoLabel !== 'N/A' && <Tag size="md" colorScheme={member.sexo?.startsWith('f') ? 'pink' : 'blue'}>{sexoLabel}</Tag>}
            <Text color="whiteAlpha.800">Edad: {age}</Text>
            <Text color="whiteAlpha.800">| Cat: {categoryLabel}</Text>
            {currentUser.uid === member.id && <Tag colorScheme="red">Tú</Tag>}
            
          </HStack>
        </Box>
        
        <ModalBody p={6}>
          <VStack spacing={4}>
            {/* --- BLOQUE AÑADIDO --- */}
            <HStack spacing={8} justify="center" w="full">
              <VStack spacing={0}>
                <Text fontSize="sm" color="gray.500">Puntos Torneo</Text>
                <Text fontSize="2xl" color="brand.600" fontWeight="bold">{member.points || 0}</Text>
              </VStack>
              <VStack spacing={0}>
                <Text fontSize="sm" color="gray.500">Puntos Retas</Text>
                <Text fontSize="2xl" color="brand.600" fontWeight="bold">{member.retasPoints || 0}</Text>
              </VStack>
            </HStack>
            {/* --- FIN DEL BLOQUE AÑADIDO --- */}

            <Button 
              as={RouterLink} 
              to="/portal/ranking" 
              onClick={onClose}
              colorScheme="purple"
              w="full"
            >
              Ver Ranking Completo
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}